module.exports = __webpack_public_path__ + "static/img/share_guide_bar@3x.988aaf4b.png";